// frontend/src/service/auth.ts
import { signup, googleAuth, verifyAuth, AuthResponse } from "./authHelper";
import axiosInstance, { decodeToken } from "../configuration/api";

// Add token refresh function
export const refreshToken = async (): Promise<AuthResponse> => {
  try {
    const response = await axiosInstance.post(
      "/api/v1/user/refresh-token",
      {},
      {
        _skipAuthRefresh: true, // Properly passed as config option
      }
    );

    const authData = {
      token: response.data.token,
      user: response.data.user,
    };
    localStorage.setItem("authData", JSON.stringify(authData));

    // Start/restart refresh timer
    startTokenRefreshTimer();

    return response.data;
  } catch (error: any) {
    localStorage.removeItem("authData");
    throw new Error(error.response?.data?.message || "Token refresh failed");
  }
};

export const login = async (email: string, password: string) => {
  try {
    const response = await axiosInstance.post("/api/v1/user/login", {
      emailAddress: email,
      password,
    });

    const authData = {
      token: response.data.token,
      user: response.data.user,
    };
    localStorage.setItem("authData", JSON.stringify(authData));

    // Start refresh timer
    startTokenRefreshTimer();

    return authData;
  } catch (error) {
    throw error;
  }
};

export const logout = async () => {
  try {
    if (refreshTimer) {
      clearTimeout(refreshTimer);
      refreshTimer = null;
    }
    await axiosInstance.post("/api/v1/user/logout");
  } finally {
    localStorage.removeItem("authData");
    window.location.href = "/";
  }
};
// Token refresh management
let refreshTimer: NodeJS.Timeout | null = null;

const startTokenRefreshTimer = () => {
  // Clear existing timer if any
  if (refreshTimer) {
    clearTimeout(refreshTimer);
  }

  // Set new timer to refresh token 5 minutes before expiration
  refreshTimer = setTimeout(async () => {
    try {
      const { token, user } = await refreshToken();
      const authData = {
        token: token,
        user: user,
      };
      localStorage.setItem("authData", JSON.stringify(authData));
      localStorage.setItem("role", user?.role);

      // Restart the timer
      startTokenRefreshTimer();
    } catch (error) {
      console.error("Token refresh failed, logging out...", error);
      logout();
      window.location.href = "/login";
    }
  }, 7 * 24 * 60 * 60 * 1000 - 5 * 60 * 1000); // 7 days - 5 minutes
};

// Add function to check auth state

export const checkAuth = async (): Promise<boolean> => {
  try {
    const authData = JSON.parse(localStorage.getItem("authData") || "{}");
    if (!authData?.token) return false;

    return await verifyAuth();
  } catch (error) {
    return false;
  }
};
export { signup, googleAuth, verifyAuth };
